import { DataTable } from 'primereact/datatable';
import { useEffect, useState } from 'react';
import { obtienePuestosActivos } from '../../services/Monitor/MonitorService';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';

const DataPuesto = () => {
    const [lstPuestos, setLstPuestos] = useState([]);
    const [cargaPuestos, setCargaPuestos] = useState(false);

    const [filtros, setFiltros] = useState({
        global: { value: null, matchMode: 'contains' },
        proyectoSigla: { value: null, matchMode: 'contains' },
        proyectoNombre: { value: null, matchMode: 'contains' },
        puestoSigla: { value: null, matchMode: 'contains' },
        puestoNombre: { value: null, matchMode: 'contains' }, 
        infoAdicional: { value: null, matchMode: 'contains' }, 
    });

    const [valoresFiltros, setValoresFiltros] = useState({
        proyectoSigla: '',
        proyectoNombre: '',
        puestoSigla: '',
        puestoNombre: '', 
        infoAdicional: '',
        global: ''
    });

    // filtro para Texto
        const textoFilterTemplate = (options, field) => {
            return (
                <InputText
                    value={valoresFiltros[field]}
                    onChange={(e) => {
                        const nuevoValor = e.target.value;
                        // Actualizamos el valor visual
                        setValoresFiltros((prev) => ({ ...prev, [field]: nuevoValor }));
    
                        // Actualizamos el filtro real después de un pequeño delay
                        setTimeout(() => {
                            const newFilters = { ...filtros };
                            newFilters[field].value = nuevoValor;
                            setFiltros(newFilters);
                            options.filterApplyCallback(nuevoValor);
                        }, 10);
                    }}
                    placeholder={`Filtro ${field}`}
                    className="w-full"
                />
            );
        };

    useEffect(() => {
        const recuperaPuestos = async () => {
            try {
                setCargaPuestos(true);
                const data = await obtienePuestosActivos();
                setLstPuestos(data);
            } catch (err) {
                console.error('Error: ', err.message);
            } finally {
                setCargaPuestos(false);
            }
        };
        recuperaPuestos();
    }, []);

    return (
        <div className="card">
            <h5>Informacion General de Puesto</h5>
            <DataTable loading={cargaPuestos} value={lstPuestos} size='small' 
              tableStyle={{ minWidth: '90rem', width: '100%' }} 
              scrollable
              dataKey="puestoId"
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 15, 20]}
              filters={filtros}
              filterDisplay="row"
              emptyMessage="No se encontraron resultados."
              >
                <Column header='Nombre Proyecto' field='proyectoNombre' filter filterPlaceholder="Filtro Proyecto" filterElement={(options) => textoFilterTemplate(options, 'proyectoNombre')} showFilterMenu={false} />
                <Column header='Sigla Proyecto' field='proyectoSigla' filter filterPlaceholder="Filtro Proyecto" filterElement={(options) => textoFilterTemplate(options, 'proyectoSigla')} showFilterMenu={false} />
                <Column header='Nombre Puesto' field='puestoNombre' filter filterPlaceholder="Filtro Puesto" filterElement={(options) => textoFilterTemplate(options, 'puestoNombre')} showFilterMenu={false}/>
                <Column header='Sigla Puesto' field='puestoSigla' filter filterPlaceholder="Filtro Puesto" filterElement={(options) => textoFilterTemplate(options, 'puestoSigla')} showFilterMenu={false} />
                {/* <Column header='Denominativo' field='denominativo' />
                <Column header='Telefono' field='telefono' />
                <Column header='Marca Rapida' field='codMarcaRapida' />*/}
                <Column header='Informacion' field='infoAdicional' filter filterPlaceholder="Filtro Puesto" filterElement={(options) => textoFilterTemplate(options, 'infoAdicional')} showFilterMenu={false} />
            </DataTable>
        </div> 
    );
};

export default DataPuesto;

